<template>
  <div id="scroll-board-right">
    <dv-border-box-6>
      <div class="table-name" style="text-align: center; padding-top: 8px">
        <img src="./img/icon5.png" />最近完成订单
      </div>
      <dv-scroll-board style="margin-top: -15px" :config="config" />
    </dv-border-box-6>
  </div>
</template>

<script>
export default {
  name: 'ScrollBoardRight',
  data () {
    return {
      config: {
        header: ['工单号', '产品编码','产品名称', '完成时间'],
        data: [],
        index: false,
        columnWidth: [160, 160, 230, 160],
        align: ['center'],
        headerHeight: 45,
        oddRowBGC: 'rgba(9, 37, 50, 0.4)',
        evenRowBGC: 'rgba(10, 32, 50, 0.3)',
        headerBGC: 'rgba(9, 37, 50, 0.4)',
        rowNum: 9,
        waitTime: 1200
      },
      lineId: undefined
    }
  },
  beforeMount(){
    const href = window.location.href
    const str = href.substr(href.indexOf("?")+1,href.length)
    const params = str.split('&')
    const code = params[0].split('=')[1]
    if (code){
      this.lineId = code;
    }
  },
  mounted () {
    const { getBigScreen } = this;
    getBigScreen();
    setInterval(getBigScreen, 30000);
  },
  methods: {
    async getBigScreen() {
      const data = await this.$http.post('https://apismt.moxitech.cn/admin-api/bigScreen/getWorkOrderList',{
        lineId: this.lineId
      }).then(res=>{
        return res.data.data
      }).catch(e=>{
        console.log(e)
      });
      this.config.data = data.map((item) => [item.workOrderCode, item.materialCode, item.materialName, this.formatDateTime(item.completedTime)]);
      this.config = { ...this.config };
    },
    formatDateTime(value) {
      if (value == null) {
        return ''
      } else {
        const date = new Date(value)
        let MM = date.getMonth() + 1 // 月
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate() // 日
        d = d < 10 ? ('0' + d) : d
        let h = date.getHours() // 时
        h = h < 10 ? ('0' + h) : h
        let m = date.getMinutes()// 分
        m = m < 10 ? ('0' + m) : m
        let s = date.getSeconds()// 秒
        s = s < 10 ? ('0' + s) : s
        return MM + '-' + d + ' ' + h + ':' + m + ':' + s
      }
    }
  }
}
</script>

<style lang="less">
#scroll-board-right {
  width: 30%;
  height: calc(100% - 550px);
  box-sizing: border-box;
  margin-left: 20px;
  overflow: hidden;
  position: absolute;
  left: 10px;
  top: 260px;
}

.border-box-content {
  padding: 20px;
  box-sizing: border-box;
}

.table-name {
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;

  img {
    width: 40px;
    height: 40px;
    margin-right: 5px;
  }
}

.dv-scroll-board {
  height: calc(~"100% - 60px");
}

#scroll-board-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
}
</style>
